import { render, staticRenderFns } from "./newAddPatrolWx.vue?vue&type=template&id=03c1ddcc&scoped=true&"
import script from "./newAddPatrolWx.vue?vue&type=script&lang=js&"
export * from "./newAddPatrolWx.vue?vue&type=script&lang=js&"
import style0 from "./newAddPatrolWx.vue?vue&type=style&index=0&id=03c1ddcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c1ddcc",
  null
  
)

export default component.exports